const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBancoColumbia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    style: {
      fill: "#003e7b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.11,14.43c-1.88-.34-3.42-1.62-4.1-3.33h5.04v-.77h-4.62c1.03-1.2,1.54-2.65,1.54-4.27,0-.34,0-.68-.09-1.03h6.41c.77,1.11,1.11,2.39,1.11,3.76,0,.51-.09,1.03-.17,1.54h-3.5v.77h4.27c-.43,1.11-1.28,1.97-2.22,2.65h0c-.08-.27-.12-.44-.22-.65-.09-.17-.38-.37-.63-.37-.34,0-.6.26-.68.51-.26.77-1.03,1.23-1.88,1.23-.16,0-.16-.02-.25-.03M8.37,13.92c.6,0,1.12-.25,1.29-.85.17-.51.68-.91,1.27-.91.34,0,.79.2.93.37.08.08.18.28.18.28.34-.34.77-.68,1.03-1.11H4.86c.77,1.2,1.88,1.97,3.33,2.22h0M6.57,6.06c0,1.37-.34,2.65-1.03,3.76h7.35c.09-.34.09-.68.09-1.03,0-1.11-.34-2.22-.85-3.16h-5.56v.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62,4.52c-.26,0-1.03-.17-1.2-.43.34.17,1.03,0,1.28-.09.09-.17.51-.6,1.03-.51v1.11c-.34-.26-1.03-.09-1.11-.09",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.84,8.77c.16-.23.23-.47.23-.62q0-.08-.08-.16c-.16-.08-.47,0-.78.23v-1.09c.31.23.62.39.78.23,0,0,.08-.08.08-.16,0-.16-.08-.39-.31-.54h1.09c-.16.23-.23.47-.23.62q0,.08.08.16c.08.08.47,0,.78-.23v1.09c-.31-.23-.62-.39-.78-.23,0,0-.08.08-.08.16,0,.16.08.39.31.54h-1.09Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBancoColumbia);
export default __webpack_public_path__ + "static/media/banco-columbia.fbc78e48619bc194360e80e5dc1aef3d.svg";
export { ForwardRef as ReactComponent };